import { render, staticRenderFns } from "./ProjectionCropChart.vue?vue&type=template&id=d989cd98&"
import script from "./ProjectionCropChart.vue?vue&type=script&lang=js&"
export * from "./ProjectionCropChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports